import { Coords } from "../../Common/types/Coords";

export function toLatLngLiteral(coords: Coords): google.maps.LatLngLiteral {
  return {
    lat: coords.latitude,
    lng: coords.longitude,
  };
}
